import { render, staticRenderFns } from "./TerritorialUnitAllocationListFilter.vue?vue&type=template&id=2eb24b1f&"
import script from "./TerritorialUnitAllocationListFilter.vue?vue&type=script&lang=js&"
export * from "./TerritorialUnitAllocationListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports